import React from 'react';

const Input = ({ label, name, value, placeholder, onChange }) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input
        type="text"
        className="regular-text"
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/forms/input.jsx